import { gql } from "@apollo/client"

export const GET_COMPANY = gql`
  query GetCompany($companyId: ID) {
    getCompany(company_id: $companyId) {
      id
      name
      currency
      country_code
      company_country
      email
      phone_number
      farmed_out_enabled
      active_subscription {
        id
        status
        plan {
          id
          name
          modules {
            id
            name
          }
        }
      }
    }
  }
`